// extracted by mini-css-extract-plugin
export default {"smart-banner-spacer":"styles__smart-banner-spacer--C7um3","smart-banner-fix":"styles__smart-banner-fix--409id"};